// Yurt içi sürücü maaş süreci — kalem penceresindeki "kaydetmeden önce sonuç" ön izlemesi.
// Backend'deki TMS.Business.Helpers.DomesticDriverSalaryCalculator'ın birebir karşılığıdır;
// kaydedilen değer HER ZAMAN backend hesabıdır. Formül değişirse iki dosya birlikte değişmelidir.
//
// AFOK (AO) ve YİÜ (SGK) (AP) ayrı kalem: Toplam Prim'den düşülür, Banka 1'e eklenir (İK Excel'i, 13.10.2026).
// Bordro Prim kapalı formu (AR + AS = AQ koşulundan):
//   AR = (AE − AK − AL − AO − AP − S·(htm·HTM + gtm·GTM)/d) / (1 + ((fm−1)·FM + htm·HTM + gtm·GTM)/d),  d = 30 × günlük mesai saati

const r2 = v => Math.round((v + Number.EPSILON) * 100) / 100

export function calculateDomesticDriverSalary(i) {
    const d = 30 * (i.GunlukMesaiSaat ?? 7.5)
    const fm = i.FmCarpan ?? 1.5
    const htm = i.HtmCarpan ?? 1.5
    const gtm = i.GtmCarpan ?? 1
    const r = { Uyarilar: [] }

    r.KalanHakedis = r2(i.ToplamHakedis - i.Banka2TrafikCezasi - i.Banka2Vukuat - i.Banka2Avans)
    r.Harcirah = r2(i.HarcirahElle ?? i.NGunu * i.HarcirahGunluk)
    const yemekKart = r2(i.YemekKart)
    r.SgkHakedis = r2(r.KalanHakedis - r.Harcirah - yemekKart)

    r.MaasSgkTl = r2(i.SgkMaas / 30 * i.UcreteTabiGun)
    r.FmTl = r2(i.SgkMaas / d * fm * i.FmSaat)
    r.Afok = r2(i.Afok)
    r.YillikIzinSgk = r2(i.YillikIzinSgk || 0)
    const htmGtm = htm * i.HtmSaat + gtm * i.GtmSaat
    r.BordroPrim = r2((r.SgkHakedis - r.MaasSgkTl - r.FmTl - r.Afok - r.YillikIzinSgk - i.SgkMaas * htmGtm / d) / (1 + ((fm - 1) * i.FmSaat + htmGtm) / d))
    r.HtmTl = r2((i.SgkMaas + r.BordroPrim) / d * htm * i.HtmSaat)
    r.GtmTl = r2((i.SgkMaas + r.BordroPrim) / d * gtm * i.GtmSaat)

    r.ToplamPrim = r2(r.SgkHakedis - r.MaasSgkTl - r.FmTl - r.HtmTl - r.GtmTl - r.Afok - r.YillikIzinSgk)
    r.PrimMesai = r2(r.ToplamPrim - r.BordroPrim)

    const kesinti = i.Avans + i.Icra + i.Bes + i.Kesinti + i.TrafikCezasi + i.BelgeIleOdenen
    r.Banka1Odeme = r2(r.MaasSgkTl + r.FmTl + r.HtmTl + r.GtmTl + r.Afok + r.YillikIzinSgk + r.ToplamPrim - kesinti)
    r.Banka2Kontrol = r2(r.KalanHakedis - kesinti - r.Banka1Odeme - r.Harcirah - yemekKart)

    const uyar = (v, ad) => { if (v < 0) r.Uyarilar.push(`${ad} eksi çıktı.`) }
    uyar(r.SgkHakedis, 'SGK Hakediş')
    uyar(r.ToplamPrim, 'Toplam Prim')
    uyar(r.BordroPrim, 'Bordro Prim')
    uyar(r.PrimMesai, 'Prim Mesai')
    uyar(r.Banka1Odeme, 'Ödeme [Banka 1]')
    if (r.Banka2Kontrol !== 0) r.Uyarilar.push('Ödeme [Banka 2] sıfır değil.')
    return r
}

// Satır modelinden (DomesticDriverSalaryRowModel) hesap girdisi üretir; düzenlenen G kalemleri ve harcırah üzerine yazılır.
export function inputFromRow(row, edits = {}) {
    const g = { ...row, ...edits }
    const primToplam = g.Prim + g.DestekPrimi + g.MazotPrimi + g.HammaliyeBedeli + g.Yatma
    const toplamHakedis = r2(g.CalismaKazanci + g.YillikIzinKazanc + g.MesaiUcreti + g.BayramMesaisi + g.YemekUcreti + g.YolUcreti +
        primToplam + g.Sifirlama + g.Diger + g.MaasDestekFiili)
    return {
        ToplamHakedis: toplamHakedis,
        Banka2TrafikCezasi: g.Banka2TrafikCezasi, Banka2Vukuat: g.Banka2Vukuat, Banka2Avans: g.Banka2Avans,
        NGunu: g.NGunu, HarcirahGunluk: g.HarcirahGunluk, HarcirahElle: g.HarcirahElle ?? null,
        YemekKart: g.YemekUcreti,
        SgkMaas: g.SgkMaas, UcreteTabiGun: g.UcreteTabiGun,
        FmSaat: g.FmSaat, HtmSaat: g.HtmSaat, GtmSaat: g.GtmSaat, Afok: g.Afok,
        // YİÜ (SGK) = G tarafındaki YİÜ (İK Excel'inde iki sütun aynı tutar).
        YillikIzinSgk: g.YillikIzinKazanc,
        Avans: g.Avans, Icra: g.Icra, Bes: g.Bes, Kesinti: g.Kesinti, TrafikCezasi: g.TrafikCezasi, BelgeIleOdenen: g.BelgeIleOdenen
    }
}

// Toplam Prim'i tam 0 yapan (eksi primi gideren) en yüksek harcırah. HTM/GTM bazı Bordro Prim'e bağlı olduğundan
// harcırah ile prim bire bir değişmez; Bordro Prim = 0 noktası: AE* = AK + AL + AO + AP + S·(htm·HTM + gtm·GTM)/d.
export function maxHarcirahForNonNegativePrim(i) {
    const d = 30 * (i.GunlukMesaiSaat ?? 7.5)
    const fm = i.FmCarpan ?? 1.5
    const htm = i.HtmCarpan ?? 1.5
    const gtm = i.GtmCarpan ?? 1
    const kalan = r2(i.ToplamHakedis - i.Banka2TrafikCezasi - i.Banka2Vukuat - i.Banka2Avans)
    const ak = r2(i.SgkMaas / 30 * i.UcreteTabiGun)
    const al = r2(i.SgkMaas / d * fm * i.FmSaat)
    const aeMin = ak + al + r2(i.Afok) + r2(i.YillikIzinSgk || 0) + i.SgkMaas * (htm * i.HtmSaat + gtm * i.GtmSaat) / d
    // 10 kuruş pay: HTM/GTM ve Bordro Prim 2 haneye yuvarlandığından tam sınırda Bordro Prim / Prim Mesai −0,01 çıkabiliyor.
    return Math.max(0, r2(Math.floor((kalan - r2(i.YemekKart) - aeMin) * 100) / 100 - 0.10))
}
